import { render, staticRenderFns } from "./JoinConversationForm.vue?vue&type=template&id=af72a2f4"
import script from "./JoinConversationForm.vue?vue&type=script&lang=js"
export * from "./JoinConversationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports